(() => {
  // Selecting a custom block in the editor reveals its complete ancestry.
  document.addEventListener('shopify:block:select', event => {
    const item = event.target.closest('.header-menu-item');
    if (!item) return;
    const header = item.closest('[data-logo-menu]');
    if (header && !header.classList.contains('is-open')) header.querySelector('.logo-link')?.click();
    const dialog = item.closest('dialog');
    if (dialog && !dialog.open) dialog.showModal();
    for (let parent = item.parentElement; parent; parent = parent.parentElement) if (parent.tagName === 'DETAILS') parent.open = true;
    item.querySelector(':scope > details')?.setAttribute('open', '');
    item.scrollIntoView({block:'nearest',behavior:'instant'});
  });
})();
